export default {
    text: "Text",
    numeric: "Numeric",
    yesno: "YesNo",
}
